module.exports = __webpack_public_path__ + "img/times1.557eb3fc.jpg";